module.exports = __webpack_public_path__ + "static/media/logo.166136cd.svg";